import React from 'react';
import * as Portals from 'react-reverse-portal';
import { Map } from '@leverege/ui-mapbox-elements';
import { jsx as _jsx } from "react/jsx-runtime";
class Listeners {
  constructor() {
    this.listeners = [];
  }

  /**
   * Adds a listener to the manager
   */
  addListener(l) {
    if (!this.listeners.includes(l)) {
      this.listeners.push(l);
    }
  }

  /**
   * Removes a listener from the manager
   */
  removeListener(l) {
    const idx = this.listeners.indexOf(l);
    if (idx >= 0) {
      this.listeners.splice(idx, 1);
    }
  }
  fireEvent(evt) {
    this.listeners.forEach(listener => {
      listener(evt);
    });
  }
}
let locks = 1;
class Slot {
  static locks = 1;
  static num = 0;
  constructor(locked = false) {
    this.key = {
      l: locks++
    };
    this.id = `SM-${Slot.num++}`;
    this.locked = locked;
    this.sentMap = false;
    this.forwardMapReady = null;
    this.node = Portals.createHtmlPortalNode();
  }
  unlock() {
    this.locked = false;
    this.sentMap = false;
    this.key = {
      l: Slot.locks++
    }; // a key is used only once
  }
  setOnMapReady(cb) {
    this.forwardMapReady = cb;
    this.fireMapReady();
  }
  onMapReady = map => {
    this.map = map;
    this.fireMapReady();
  };
  fireMapReady() {
    if (this.map && this.forwardMapReady && !this.sentMap) {
      this.sentMap = true;
      setTimeout(() => {
        this.forwardMapReady(this.map);
      }, 1);
    }
  }
}
const portals = [];
//   { 
//   key : { l : locks++ }, id : 'SM-1', locked : false, node : Portals.createHtmlPortalNode()
// } ]
const globalListeners = new Listeners();
export default class SharedMaps extends React.Component {
  static lock() {
    for (let n = 0; n < portals.length; n++) {
      if (!portals[n].locked) {
        portals[n].locked = true;
        return portals[n].key;
      }
    }
    // console.log( '+++++++ Shared Map Unavailable. Create New One.' )

    // None available. create a new one
    const rtn = new Slot(true);
    // {
    //   node : Portals.createHtmlPortalNode(),
    //   key : { l : locks++ },
    //   id : `SM-${portals.length + 1}`,
    //   locked : true
    // } 
    portals.push(rtn);
    globalListeners.fireEvent();
    return rtn.key;
  }
  static unlock(key) {
    const f = portals.find(p => p.key === key);
    if (f) {
      f.unlock();
      // f.locked = false
      // f.key = { l : locks++ } // a key is used only once
      return true;
    }
    return false;
  }
  static renderMap(key, props) {
    const p = portals.find(p => p.key === key);
    if (p) {
      const {
        onMapReady,
        ...rest
      } = props;
      p.setOnMapReady(onMapReady);
      return /*#__PURE__*/_jsx(Portals.OutPortal, {
        node: p.node,
        ...rest
      });
    }
    return null;
  }
  onChange = evt => {
    this.forceUpdate();
  };
  componentDidMount() {
    globalListeners.addListener(this.onChange);
  }
  componentWillUnmount() {
    globalListeners.removeListener(this.onChange);
  }
  render() {
    return portals.map(entry => {
      const {
        node
      } = entry;
      return /*#__PURE__*/_jsx(Portals.InPortal, {
        node: node,
        children: /*#__PURE__*/_jsx(Map, {
          onMapReady: entry.onMapReady
        })
      }, entry.id);
    });
  }
}